module.exports = __webpack_public_path__ + "static/img/logo_24.c999f99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_24.png
// module id = eApV
// module chunks = 1